import { createFileRoute } from "@tanstack/react-router";

import React from "react";
import HeadingLayout from "src/components/base/heading-layout";
import { useTranslation } from "react-i18next";
import Stat from "src/components/base/stat";
import { ApiInternal } from "src/api/api_internal";

/**
 * The properties for {@link Dashboard}
 */
export type DashboardProps = {};

/**
 * The admin dashboard
 */
function Dashboard(props: DashboardProps) {
    const [t] = useTranslation("admin-dashboard");

    const data = Route.useLoaderData();

    return (
        <HeadingLayout heading={t("heading.welcome")}>
            <div className={"grid grid-cols-4 gap-12"}>
                <Stat label={t("label.server-devices")} value={data.total_servers} />
                <Stat label={t("label.client-devices")} value={data.total_clients} />
            </div>
        </HeadingLayout>
    );
}

export const Route = createFileRoute("/_admin/a/dashboard/")({
    component: Dashboard,
    loader: async () => await ApiInternal.devices.getAll({ offset: 0, limit: 0 }),
});
